export default function({ store }) {
	return store.dispatch('bank/GetAccountBankCardCount')
}